import ComponentBase from './base/component-base';
import ComponentInitializer from '../libs/component-initializer';
import { EVENT_GLOBAL_NAV_TOGGLE } from '../constants/event';
import ScrollLock from '../libs/scroll-lock';
import ClipPathPolygon from '../libs/clip-path-polygon';
import Point from '../libs/point';

export default class GlobalNavComponent extends ComponentBase {
  protected isOpen: boolean = false;
  protected isInnerActive: boolean = false;

  protected documentClickBind: EventListener | null = null;
  protected clipPathPolygon: ClipPathPolygon | null = null;

  protected mainElement: HTMLElement | null = null;
  protected innerElement: HTMLElement | null = null;

  constructor(element: HTMLElement) {
    super(element);
    this.mainElement = this.element.querySelector('.j-global-nav-main');
    this.innerElement = this.element.querySelector('.j-global-nav-inner');
    this.documentClickBind = this.onDocumentClick.bind(this);
  }

  protected onReady(): void {
    super.onReady();
    this.addEventListeners();

    this.clipPathPolygon = new ClipPathPolygon(
      new Point(100, 0),
      new Point(100, 0),
      new Point(100, 100),
      new Point(100, 100)
    );

    this.clipPathPolygon.addEventListener('onUpdate', (event) => {
      this.updateMainStyle();
      this.onClipPathUpdate(event);
    });

    this.clipPathPolygon.addEventListener('onComplete', (event) => {
      this.updateMainStyle();
      this.onClipPathComplete();
    });
  }

  private addEventListeners(): void {
    document.addEventListener(EVENT_GLOBAL_NAV_TOGGLE, this.toggle.bind(this));
  }

  private addDocumentClickEventListener(): void {
    if (this.documentClickBind) {
      document.addEventListener('click', this.documentClickBind);
    }
  }

  private removeDocumentClickEventListener(): void {
    if (this.documentClickBind) {
      document.removeEventListener('click', this.documentClickBind);
    }
  }

  private onDocumentClick(event: Event): void {
    const mouseEvent = event as MouseEvent;
    const target = mouseEvent.target as HTMLElement;
    if (!target.closest('.j-global-nav-main')) {
      mouseEvent.preventDefault();
      this.deactivate();
    }
  }

  private toggle(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.activate();
    } else {
      this.deactivate();
    }
  }

  private activate(): void {
    const duration = 0.5;
    const delay = 0.05;
    this.isOpen = true;
    this.element.classList.add('is-active');
    this.clipPathPolygon.animate('TL', { point: new Point(0, 0), duration });
    this.clipPathPolygon.animate('BL', {
      point: new Point(0, 100),
      duration: duration,
      delay: delay,
    });
    ScrollLock.getInstance().disable();

    setTimeout(() => {
      this.addDocumentClickEventListener();
    });
  }

  private deactivate(): void {
    const duration = 0.5;
    const delay = 0.05;
    this.isOpen = false;
    this.element.classList.remove('is-active');
    this.deactivateInner();
    this.clipPathPolygon.animate('TL', { point: new Point(100, 0), duration });
    this.clipPathPolygon.animate('BL', {
      point: new Point(100, 100),
      duration: duration,
      delay: delay,
    });
    ScrollLock.getInstance().enable();
    setTimeout(() => {
      this.removeDocumentClickEventListener();
    });
  }

  private activateInner(): void {
    if (!this.innerElement) return;
    if (this.isInnerActive) return;
    this.isInnerActive = true;
    this.innerElement.classList.add('is-active');
  }

  private deactivateInner(): void {
    if (!this.innerElement) return;
    if (!this.isInnerActive) return;
    this.isInnerActive = false;
    this.innerElement.classList.remove('is-active');
  }

  private onClipPathComplete(): void {
    // if (this.isOpen) {
    //   this.activateInner();
    // } else {
    //   this.deactivateInner();
    // }
  }

  private onClipPathUpdate(event: CustomEvent): void {
    const progress = event.detail.progress;
    if (progress > 0.8 && this.isOpen) {
      this.activateInner();
    }
  }

  private updateMainStyle(): void {
    if (!this.mainElement) return;
    this.mainElement.style.clipPath = this.clipPathPolygon.getClipPath();
  }
}

ComponentInitializer.initializeComponent('.j-global-nav', GlobalNavComponent);
